{
	"titlePage": "Transferts de stock",
	"tabLabel": "Transferts",
	"description": "Ce rapport permet de suivre les mouvements entre les stocks, offrant une visibilité adéquate des transferts pour les gestionnaires de stock et les responsables.",
	"actionButtons": {
		"print": "Imprimer",
		"downloadExcel": "Télécharger en Excel"
	},
	"filterToPeriod": "Filtrer par période",
	"column": {
		"dateTransfer": "Date de transfert",
		"employee": "Employé",
		"outgoingStock": "Stock sortant",
		"incomingStock": "Stock entrant",
		"inputAndProduct": "Intrant/Produit",
		"amount": "Quantité"
	},
	"employeePlaceholder": "Employé",
	"storagePlaceholder": "Stock",
	"searchBy": "Rechercher par"
}
